import { DamageType } from './damage-types';

export enum ContainerDamageLocation {
  FRONT = 'FRONT',
  DOOR = 'DOOR',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  MISC = 'MISC'
}

enum ContainerDamagePart {
  AIR_DEFLECTOR = 'AIR DEFLECTOR',
  SCUFF_PLATE = 'SCUFF PLATE',
  TOP_RAIL = 'TOP RAIL',
  PANEL = 'PANEL',
  LEFT_CAM_KEEPER = 'LEFT CAM KEEPER',
  RIGHT_CAM_KEEPER = 'RIGHT CAM KEEPER',
  LEFT_DOOR_HINGE = 'LEFT DOOR HINGE',
  RIGHT_DOOR_HINGE = 'RIGHT DOOR HINGE',
  LEFT_HANDLE = 'LEFT HANDLE',
  RIGHT_HANDLE = 'RIGHT HANDLE',
  LEFT_HANDLE_LATCH = 'LEFT HANDLE LATCH',
  RIGHT_HANDLE_LATCH = 'RIGHT HANDLE LATCH',
  LEFT_HINGE_BUTT = 'LEFT HINGE BUTT',
  RIGHT_HINGE_BUTT = 'RIGHT HINGE BUTT',
  LEFT_HINGE_PIN = 'LEFT HINGE PIN',
  RIGHT_HINGE_PIN = 'RIGHT HINGE PIN',
  LEFT_INNER_PANEL = 'LEFT INNER PANEL',
  RIGHT_INNER_PANEL = 'RIGHT INNER PANEL',
  LEFT_LOCK_CAM = 'LEFT LOCK CAM',
  RIGHT_LOCK_CAM = 'RIGHT LOCK CAM',
  LEFT_LOCKING_ROD = 'LEFT LOCKING ROD',
  RIGHT_LOCKING_ROD = 'RIGHT LOCKING ROD',
  LEFT_SEAL = 'LEFT SEAL',
  RIGHT_SEAL = 'RIGHT SEAL',
  LEFT_TIE_BACK = 'LEFT TIE BACK',
  RIGHT_TIE_BACK = 'RIGHT TIE BACK',
  ROOF_BOW = 'ROOF BOW',
  ROOF_HEADER = 'ROOF HEADER',
  TARP = 'TARP',
  TARP_CABLE = 'TARP CABLE',
  TARP_RING = 'TARP RING',
  CROSSMEMBER = 'CROSSMEMBER',
  FLOOR_BOARD = 'FLOOR BOARD',
  HAT_TRACK = 'HAT TRACK',
  T_RAIL_FLOORING = 'T RAIL FLOORING',
  VENTS = 'VENTS',
  FORK_POCKET = 'FORK POCKET',
  FRONT_CORNER_POST = 'FRONT CORNER POST',
  REAR_CORNER_POST = 'REAR CORNER POST',
  FRONT_UPPER_CORNER_CASTING = 'FRONT UPPER CORNER CASTING',
  FRONT_LOWER_CORNER_CASTING = 'FRONT LOWER CORNER CASTING',
  REAR_UPPER_CORNER_CASTING = 'REAR UPPER CORNER CASTING',
  REAR_LOWER_CORNER_CASTING = 'REAR LOWER CORNER CASTING',
  DEBRIS_DUNNAGE = 'DEBRIS DUNNAGE',
  NAILS_IN_FLOOR = 'NAILS IN FLOOR',
  PLACARDS = 'PLACARDS'
}

type T_ContainerLocationPart = { [P in ContainerDamageLocation]: keyof ContainerDamageTypes[P] };

export interface ContainerLocationPart extends T_ContainerLocationPart {
  FRONT: Extract<
    ContainerDamagePart,
    | ContainerDamagePart.AIR_DEFLECTOR
    | ContainerDamagePart.SCUFF_PLATE
    | ContainerDamagePart.TOP_RAIL
    | ContainerDamagePart.PANEL
  >;
  DOOR: Extract<
    ContainerDamagePart,
    | ContainerDamagePart.TOP_RAIL
    | ContainerDamagePart.PANEL
    | ContainerDamagePart.LEFT_CAM_KEEPER
    | ContainerDamagePart.RIGHT_CAM_KEEPER
    | ContainerDamagePart.LEFT_DOOR_HINGE
    | ContainerDamagePart.RIGHT_DOOR_HINGE
    | ContainerDamagePart.LEFT_HANDLE
    | ContainerDamagePart.RIGHT_HANDLE
    | ContainerDamagePart.LEFT_HANDLE_LATCH
    | ContainerDamagePart.RIGHT_HANDLE_LATCH
    | ContainerDamagePart.LEFT_HINGE_BUTT
    | ContainerDamagePart.RIGHT_HINGE_BUTT
    | ContainerDamagePart.LEFT_HINGE_PIN
    | ContainerDamagePart.RIGHT_HINGE_PIN
    | ContainerDamagePart.LEFT_INNER_PANEL
    | ContainerDamagePart.RIGHT_INNER_PANEL
    | ContainerDamagePart.LEFT_LOCK_CAM
    | ContainerDamagePart.RIGHT_LOCK_CAM
    | ContainerDamagePart.LEFT_LOCKING_ROD
    | ContainerDamagePart.RIGHT_LOCKING_ROD
    | ContainerDamagePart.LEFT_SEAL
    | ContainerDamagePart.RIGHT_SEAL
    | ContainerDamagePart.LEFT_TIE_BACK
    | ContainerDamagePart.RIGHT_TIE_BACK
  >;
  TOP: Extract<
    ContainerDamagePart,
    | ContainerDamagePart.PANEL
    | ContainerDamagePart.ROOF_BOW
    | ContainerDamagePart.ROOF_HEADER
    | ContainerDamagePart.TARP
    | ContainerDamagePart.TARP_CABLE
    | ContainerDamagePart.TARP_RING
  >;
  BOTTOM: Extract<
    ContainerDamagePart,
    | ContainerDamagePart.CROSSMEMBER
    | ContainerDamagePart.FLOOR_BOARD
    | ContainerDamagePart.HAT_TRACK
    | ContainerDamagePart.T_RAIL_FLOORING
  >;
  LEFT: Extract<
    ContainerDamagePart,
    | ContainerDamagePart.TOP_RAIL
    | ContainerDamagePart.PANEL
    | ContainerDamagePart.VENTS
    | ContainerDamagePart.FORK_POCKET
    | ContainerDamagePart.FRONT_CORNER_POST
    | ContainerDamagePart.REAR_CORNER_POST
    | ContainerDamagePart.FRONT_UPPER_CORNER_CASTING
    | ContainerDamagePart.FRONT_LOWER_CORNER_CASTING
    | ContainerDamagePart.REAR_UPPER_CORNER_CASTING
    | ContainerDamagePart.REAR_LOWER_CORNER_CASTING
  >;
  RIGHT: Extract<
    ContainerDamagePart,
    | ContainerDamagePart.TOP_RAIL
    | ContainerDamagePart.PANEL
    | ContainerDamagePart.VENTS
    | ContainerDamagePart.FORK_POCKET
    | ContainerDamagePart.FRONT_CORNER_POST
    | ContainerDamagePart.REAR_CORNER_POST
    | ContainerDamagePart.FRONT_UPPER_CORNER_CASTING
    | ContainerDamagePart.FRONT_LOWER_CORNER_CASTING
    | ContainerDamagePart.REAR_UPPER_CORNER_CASTING
    | ContainerDamagePart.REAR_LOWER_CORNER_CASTING
  >;
  MISC: Extract<
    ContainerDamagePart,
    ContainerDamagePart.DEBRIS_DUNNAGE | ContainerDamagePart.NAILS_IN_FLOOR | ContainerDamagePart.PLACARDS
  >;
}

export type ContainerDamageTypes = {
  [P in ContainerDamageLocation]: { [Q in ContainerDamagePart]?: DamageType[] };
};

export const containerSystems: ContainerDamageTypes = {
  FRONT: {
    [ContainerDamagePart.AIR_DEFLECTOR]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CRACKED,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.LOOSE,
      DamageType.MISSING
    ],
    [ContainerDamagePart.SCUFF_PLATE]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.LOOSE,
      DamageType.MISSING
    ],
    [ContainerDamagePart.TOP_RAIL]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.MISSING
    ],
    [ContainerDamagePart.PANEL]: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CUT]
  },
  DOOR: {
    [ContainerDamagePart.TOP_RAIL]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.MISSING
    ],
    [ContainerDamagePart.PANEL]: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CUT],
    [ContainerDamagePart.LEFT_CAM_KEEPER]: [DamageType.BENT, DamageType.BROKEN, DamageType.LOOSE, DamageType.MISSING],
    [ContainerDamagePart.RIGHT_CAM_KEEPER]: [DamageType.BENT, DamageType.BROKEN, DamageType.LOOSE, DamageType.MISSING],
    [ContainerDamagePart.LEFT_DOOR_HINGE]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.RIGHT_DOOR_HINGE]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.LEFT_HANDLE]: [DamageType.BENT, DamageType.BROKEN, DamageType.IMPROPER, DamageType.MISSING],
    [ContainerDamagePart.RIGHT_HANDLE]: [DamageType.BENT, DamageType.BROKEN, DamageType.IMPROPER, DamageType.MISSING],
    [ContainerDamagePart.LEFT_HANDLE_LATCH]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.RIGHT_HANDLE_LATCH]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.LEFT_HINGE_BUTT]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.FROZEN_OR_SEIZED
    ],
    [ContainerDamagePart.RIGHT_HINGE_BUTT]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.FROZEN_OR_SEIZED
    ],
    [ContainerDamagePart.LEFT_HINGE_PIN]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.RIGHT_HINGE_PIN]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.LEFT_INNER_PANEL]: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CUT],
    [ContainerDamagePart.RIGHT_INNER_PANEL]: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CUT],
    [ContainerDamagePart.LEFT_LOCK_CAM]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.RIGHT_LOCK_CAM]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.LEFT_LOCKING_ROD]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.RIGHT_LOCKING_ROD]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.FROZEN_OR_SEIZED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.LEFT_SEAL]: [DamageType.CUT, DamageType.MISSING],
    [ContainerDamagePart.RIGHT_SEAL]: [DamageType.CUT, DamageType.MISSING],
    [ContainerDamagePart.LEFT_TIE_BACK]: [DamageType.BENT, DamageType.BROKEN, DamageType.MISSING],
    [ContainerDamagePart.RIGHT_TIE_BACK]: [DamageType.BENT, DamageType.BROKEN, DamageType.MISSING]
  },
  TOP: {
    [ContainerDamagePart.PANEL]: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CUT],
    [ContainerDamagePart.ROOF_BOW]: [DamageType.BENT, DamageType.BROKEN, DamageType.IMPROPER, DamageType.MISSING],
    [ContainerDamagePart.ROOF_HEADER]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.MISSING
    ],
    [ContainerDamagePart.TARP]: [
      DamageType.CUT,
      DamageType.IMPROPER,
      DamageType.LEAKING,
      DamageType.LOOSE,
      DamageType.MISSING
    ],
    [ContainerDamagePart.TARP_CABLE]: [DamageType.CUT, DamageType.IMPROPER, DamageType.LOOSE, DamageType.MISSING],
    [ContainerDamagePart.TARP_RING]: [DamageType.CUT, DamageType.IMPROPER, DamageType.MISSING]
  },
  BOTTOM: {
    [ContainerDamagePart.CROSSMEMBER]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.CUT,
      DamageType.MISSING
    ],
    [ContainerDamagePart.FLOOR_BOARD]: [
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.IMPROPER,
      DamageType.LOOSE,
      DamageType.MISSING,
      DamageType.SATURATED,
      DamageType.SEPARATED
    ],
    [ContainerDamagePart.HAT_TRACK]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.LOOSE,
      DamageType.MISSING,
      DamageType.SEPARATED
    ],
    [ContainerDamagePart.T_RAIL_FLOORING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CRACKED,
      DamageType.IMPROPER,
      DamageType.MISSING,
      DamageType.SEPARATED
    ]
  },
  LEFT: {
    [ContainerDamagePart.TOP_RAIL]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.MISSING
    ],
    [ContainerDamagePart.PANEL]: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CUT],
    [ContainerDamagePart.VENTS]: [DamageType.BROKEN, DamageType.CRACKED, DamageType.MISSING],
    [ContainerDamagePart.FORK_POCKET]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.CRACKED
    ],
    [ContainerDamagePart.FRONT_CORNER_POST]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.REAR_CORNER_POST]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.FRONT_UPPER_CORNER_CASTING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.FRONT_LOWER_CORNER_CASTING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.REAR_UPPER_CORNER_CASTING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.REAR_LOWER_CORNER_CASTING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.MISSING
    ]
  },
  RIGHT: {
    [ContainerDamagePart.TOP_RAIL]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.MISSING
    ],
    [ContainerDamagePart.PANEL]: [DamageType.BENT, DamageType.CORRODED_OR_ROTTED, DamageType.CUT],
    [ContainerDamagePart.VENTS]: [DamageType.BROKEN, DamageType.CRACKED, DamageType.MISSING],
    [ContainerDamagePart.FORK_POCKET]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.CRACKED
    ],
    [ContainerDamagePart.FRONT_CORNER_POST]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.REAR_CORNER_POST]: [
      DamageType.BENT,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CUT,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.FRONT_UPPER_CORNER_CASTING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.FRONT_LOWER_CORNER_CASTING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.REAR_UPPER_CORNER_CASTING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.MISSING
    ],
    [ContainerDamagePart.REAR_LOWER_CORNER_CASTING]: [
      DamageType.BENT,
      DamageType.BROKEN,
      DamageType.CORRODED_OR_ROTTED,
      DamageType.CRACKED,
      DamageType.MISSING
    ]
  },
  MISC: {
    [ContainerDamagePart.DEBRIS_DUNNAGE]: [DamageType.IMPROPER],
    [ContainerDamagePart.NAILS_IN_FLOOR]: [DamageType.IMPROPER],
    [ContainerDamagePart.PLACARDS]: [DamageType.IMPROPER]
  }
};
